import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PreferenceTemplate = ({ template, onEdit, onDelete, onUse }) => {
  const navigate = useNavigate();

  const handleUse = () => {
    if (onUse) {
      onUse(template?.id);
    } else {
      navigate(`/planner-setup-wizard?template=${template?.id}`);
    }
  };

  const getTemplateIcon = (type) => {
    switch (type) {
      case 'daily':
        return 'Calendar';
      case 'weekly':
        return 'CalendarDays';
      case 'monthly':
        return 'CalendarRange';
      case 'yearly':
        return 'CalendarCheck';
      case 'custom':
        return 'Settings';
      default:
        return 'FileText';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-all duration-200 group">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon 
              name={getTemplateIcon(template?.type)} 
              size={20} 
              className="text-primary" 
            />
          </div>
          <div>
            <h4 className="font-heading font-semibold text-foreground">
              {template?.name}
            </h4>
            <p className="font-caption text-xs text-muted-foreground">
              {template?.type} • Used {template?.usageCount} times
            </p>
          </div>
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onEdit(template?.id)}
          iconName="Edit"
          iconSize={14}
        />
      </div>
      <p className="font-body text-sm text-muted-foreground mb-4 line-clamp-2">
        {template?.description}
      </p>
      {/* Template Settings Preview */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-xs">
          <span className="font-caption text-muted-foreground">Layout:</span>
          <span className="font-caption text-foreground">{template?.settings?.layout}</span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="font-caption text-muted-foreground">Color Theme:</span>
          <div className="flex items-center space-x-1">
            <div 
              className="w-3 h-3 rounded-full border border-border"
              style={{ backgroundColor: template?.settings?.primaryColor }}
            />
            <span className="font-caption text-foreground">{template?.settings?.colorTheme}</span>
          </div>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="font-caption text-muted-foreground">Features:</span>
          <span className="font-caption text-foreground">
            {template?.settings?.features?.length} enabled
          </span>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex items-center space-x-2">
        <Button
          variant="default"
          size="sm"
          onClick={handleUse}
          iconName="Plus"
          iconPosition="left"
          iconSize={14}
          className="flex-1"
        >
          Use Template
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDelete(template?.id)}
          iconName="Trash2"
          iconSize={14}
        />
      </div>
    </div>
  );
};

export default PreferenceTemplate;